import React, { useState } from 'react';
import { Layout, Typography, Form, Input, Button, Alert, Spin, Avatar } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';

const { Content, Header } = Layout;
const { Title, Text } = Typography;

const AdminLogin = () => {
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await fetch('/backend/admin_login.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          email: values.email,
          password: values.password,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setSuccess('Login successful! Redirecting to dashboard...');
        setError(null);
        setTimeout(() => navigate('/adminpage'), 2000);
      } else {
        setError(result.error || 'Error during login.');
        setSuccess(null);
      }
    } catch (error) {
      setError('An error occurred during login.');
      setSuccess(null);
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <Layout className="auth-layout" style={{ background: '#f9fafb' }}>
      <Header className="auth-header">
        <div className="logo" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Avatar
            src="components/nhguidelogo.jpg" // Remplace par ton logo (ex. '/logo.png')
            alt="NH Guide Service Provider Logo"
            style={{ width: 40, height: 40, backgroundColor: '#fff', border: '1px solid #d9d9d9' }}
          />
          <Title level={4} className="logo-text">
            NH Guide - Service Provider
          </Title>
        </div>
      </Header>
      <Content className="auth-content">
        <div className="auth-container">
          <Title level={2} className="auth-title">
            Login as Service Provider
          </Title>
          <Text className="auth-subtitle">
            Log in to your Service Provider account to manage and Provide Services.
          </Text>
          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              className="auth-alert auth-alert-error"
            />
          )}
          {success && (
            <Alert
              message={success}
              type="success"
              showIcon
              className="auth-alert auth-alert-success"
            />
          )}
          <Form
            form={form}
            name="adminLogin"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout="vertical"
            className="auth-form"
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: 'Please enter your email!' },
                { type: 'email', message: 'Please enter a valid email!' },
              ]}
            >
              <Input
                prefix={<UserOutlined className="input-icon" />}
                placeholder="admin@example.com"
                size="large"
                className="auth-input"
              />
            </Form.Item>
            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: 'Please enter your password!' }]}
            >
              <Input.Password
                prefix={<LockOutlined className="input-icon" />}
                placeholder="Password"
                size="large"
                className="auth-input"
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                block
                className="auth-button"
                disabled={loading}
              >
                {loading ? <Spin size="small" /> : 'Log in'}
              </Button>
            </Form.Item>
            <Text className="auth-link-text">
              No account?{' '}
              <a onClick={() => navigate('/adminregister')} className="auth-link">
                Register
              </a>
            </Text>
          </Form>
        </div>
      </Content>
    </Layout>
  );
};

export default AdminLogin;